import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter66.json";
import Head from "next/head";
export default function Chapter_66() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>

      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Theurgy embraces all faiths as reflections of one Infinite Being, uniting diverse paths in divine harmony."
        ></meta>
        <meta
          property="og:title"
          content="Unity in Divine Diversity: A Theurgist’s Perspective on Faith"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Theurgists honor all sincere spiritual paths, seeing every faith as a reflection of the same Divine Infinite Being. From Christian liturgy to Hindu ritual, each tradition offers unique veils through which the Infinite reveals itself. This perspective embraces diversity, affirms unity, and transcends religious boundaries, recognizing the shared quest for divine connection at the heart of human experience"
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=66"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=66"
        ></meta>
        <meta
          name="twitter:title"
          content="Unity in Divine Diversity: A Theurgist’s Perspective on Faith"
        ></meta>

        <meta
          name="twitter:description"
          content="In theurgy, no single tradition holds a monopoly on divine truth. Every religion, symbol, and ritual becomes a portal to the Infinite. From Platonic metaphysics to sacred liturgy, diverse expressions enrich humanity’s spiritual journey. By valuing all paths, theurgists affirm unity in diversity, seeing each believer as a child of the one Supreme Self."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=66" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
